'use strict';

const {button, i} = require('iblokz-snabbdom-helpers');

const fallbackCopy = text => {
	const ta = document.createElement('textarea');
	ta.value = text;
	ta.setAttribute('readonly', '');
	ta.style.position = 'fixed';
	ta.style.left = '-9999px';
	document.body.appendChild(ta);
	ta.select();
	let ok = false;
	try {
		ok = document.execCommand('copy');
	} catch (err) {
		ok = false;
	}
	document.body.removeChild(ta);
	return ok;
};

const flashCopied = (el, label) => {
	if (!el) return;
	el.classList.add('is-copied');
	el.setAttribute('data-copied', label || 'Copied');
	clearTimeout(el._copyableTimer);
	el._copyableTimer = setTimeout(() => {
		el.classList.remove('is-copied');
		el.removeAttribute('data-copied');
	}, 1400);
};

/**
 * Click-to-copy text control.
 * Markup: button > text + optional icon. Feedback via [data-copied]::after.
 */
module.exports = ({
	text,
	sel = '',
	title = 'Copy',
	copiedLabel = 'Copied',
	icon = true
}) => {
	const value = text == null ? '' : String(text);
	if (!value) return '';

	return button(`.comp-copyable${sel}`, {
		attrs: {
			type: 'button',
			title,
			'aria-label': title
		},
		on: {
			click: ev => {
				ev.preventDefault();
				const el = ev.currentTarget;
				const done = () => flashCopied(el, copiedLabel);
				if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
					navigator.clipboard.writeText(value).then(done).catch(() => {
						if (fallbackCopy(value)) done();
					});
					return;
				}
				if (fallbackCopy(value)) done();
			}
		}
	}, [].concat(
		value,
		icon ? i('.fa.fa-clipboard') : []
	));
};
